// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"1498ea93","105":"1ff6b3d1","147":"824f7bbd","306":"811af83c","465":"64d0706e","653":"b6ef2652","689":"0c654eea","722":"83aeb356","846":"72e26d06","905":"6d30de0e","952":"20b2ce24"}[chunkId] + ".chunk.js";
};